'use client';

import { useRouter } from '@bprogress/next/app';

import { UiArticleSectionFaq } from '@/fo/ui/article/section/faq';

export function Faq() {
  const router = useRouter();
  const openAccountRoute = (path: string) => () => {
    router.push(path);
  };

  const handleClickTypeSkin = openAccountRoute('/account/#type_skin');

  return <UiArticleSectionFaq onClickTypeSkin={handleClickTypeSkin} />;
}
